
import React, { useState } from "react";
import { LanguageEngagement } from './LanguageEngagement';
import { TopTweetsAndKols } from './TopTweetsAndKols';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const TwitterKolDashboard = () => {
  const [timeFilter, setTimeFilter] = useState("all");
  const [quarterFilter, setQuarterFilter] = useState("all");
  const [yearFilter, setYearFilter] = useState("2025");
  
  // Current year for the filter options
  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from(
    { length: 5 }, 
    (_, i) => (currentYear - 2 + i).toString()
  );

  // Handle filter changes
  const handleTimeFilterChange = (value: string) => {
    console.log("Time filter changed to:", value);
    setTimeFilter(value);
  };

  const handleYearFilterChange = (value: string) => {
    console.log("Year filter changed to:", value);
    setYearFilter(value);
  };

  const handleQuarterFilterChange = (value: string) => {
    console.log("Quarter filter changed to:", value);
    setQuarterFilter(value);
  };
  
  return (
    <Card className="bg-card border border-border rounded-md shadow-sm">
      <CardHeader className="border-b border-border pb-3 flex flex-row justify-between items-center">
        <CardTitle>Twitter Dashboard</CardTitle>
        
        {/* Time filters moved inside the card header */}
        <div className="flex items-center gap-4">
          <Select value={timeFilter} onValueChange={handleTimeFilterChange}>
            <SelectTrigger className="w-[180px]">
              <SelectValue placeholder="Select time period" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Time</SelectItem>
              <SelectItem value="1m">Last Month</SelectItem>
              <SelectItem value="3m">Last 3 Months</SelectItem>
              <SelectItem value="6m">Last 6 Months</SelectItem>
              <SelectItem value="1y">Last Year</SelectItem>
            </SelectContent>
          </Select>
          
          <Select value={yearFilter} onValueChange={handleYearFilterChange}>
            <SelectTrigger className="w-[180px]">
              <SelectValue placeholder="Select year" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Years</SelectItem>
              {yearOptions.map(year => (
                <SelectItem key={year} value={year}>{year}</SelectItem>
              ))}
            </SelectContent>
          </Select>
          
          <Select value={quarterFilter} onValueChange={handleQuarterFilterChange}>
            <SelectTrigger className="w-[180px]">
              <SelectValue placeholder="Select quarter" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Quarters</SelectItem>
              <SelectItem value="Q1">Q1 (Jan-Mar)</SelectItem>
              <SelectItem value="Q2">Q2 (Apr-Jun)</SelectItem>
              <SelectItem value="Q3">Q3 (Jul-Sep)</SelectItem>
              <SelectItem value="Q4">Q4 (Oct-Dec)</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </CardHeader>
      
      <CardContent className="p-6 space-y-6">
        {/* Main content with two columns */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Left column - Language Distribution */}
          <div>
            {/* TwitterDashboardOverview component has been removed as requested */}
            
            {/* Tweet Distribution by Language - passing filters */}
            <LanguageEngagement 
              timeFilter={timeFilter} 
              quarterFilter={quarterFilter} 
              yearFilter={yearFilter}
            />
          </div>
          
          {/* Right column - Top Performing Tweets */}
          <div>
            <TopTweetsAndKols 
              timeFilter={timeFilter}
              quarterFilter={quarterFilter}
              yearFilter={yearFilter}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
